export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const URL_VALIDATION = new RegExp(
  // eslint-disable-next-line no-useless-escape
  /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi
);

export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!#$%&()*+,\-./:;<=>?@[\]^_`{|}~])[a-zA-Z\d!#$%&()*+,\-./:;<=>?@[\]^_`{|}~]{8,}$/;

export const URL_PATTERN = /(http[s]?:\/\/(?:[a-zA-Z]|[0-9]|[$-_@.&+]|[!*\\(\\),]|(?:%[0-9a-fA-F][0-9a-fA-F]))+)/;

export const UPPERCASE_LETTERS = /[A-Z]/;
export const LOWERCASE_LETTERS = /[a-z]/;
export const ONLY_DIGITS = /\d/;
export const PASSWORD_SYMBOLS = /[!#$%&()*+,\-./:;<=>?@\[\]^_`{|}~]/;